import { FileActionsMenu, useFileActionItems } from "@shared";

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onRename: () => void;
  onDownload: () => void;
  onDelete: () => void;
  onCreateCaseNote?: () => void;
  onConvertToPdf?: () => void;
  onPreview: () => void;
}

export function DocumentWidgetMenu({
  anchorEl,
  onClose,
  onRename,
  onDownload,
  onDelete,
  onCreateCaseNote,
  onConvertToPdf,
  onPreview,
}: Props) {
  const items = useFileActionItems({ onPreview, onRename, onDownload, onCreateCaseNote, onConvertToPdf, onDelete });

  return <FileActionsMenu anchorEl={anchorEl} onClose={onClose} items={items} minWidth={300} />;
}
